import { query_prestazioni_byFascicolo } from "../query/prestazioniQueries";
import {useQuery} from "@1f/react-sdk";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { query_prestazione_byTenant_Prest_stats } from "../query/statsQueries";

export const PrestazioniApi = () => {
    const errorApiHelpers = apiErrorHelper();
    const apiPrestazioniByFascicolo = useQuery(
        query_prestazioni_byFascicolo,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiPrestByTenantPrestStats = useQuery(
        query_prestazione_byTenant_Prest_stats,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );

    const GetPrestazioniByFascicoloId = async (fascicoloId)=>{
        try {
            const prestazioniResponse = await apiPrestazioniByFascicolo.fetch({
                fascicoloId: fascicoloId,
            });
            if(!prestazioniResponse.data.errors){
                return prestazioniResponse.data.data.prestazione
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le prestazioni");
        }
    }
    const GetPrestazioniRischioStats = async (tenantId,aziendaId)=>{
        try {
            let prestStatsResponse =await apiPrestByTenantPrestStats.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
            });
            if(prestStatsResponse && prestStatsResponse.data){
                return prestStatsResponse.data.data.prestazione
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le statistiche delle prestazioni");
        }
    }
    return{
        GetPrestazioniByFascicoloId,
        GetPrestazioniRischioStats
    }
}

export default PrestazioniApi;